/* Alhana — product page (sections/main-product.liquid) and the related-products loader
   (sections/product-recommendations.liquid). Vanilla, no dependencies; both sections load this file, so it
   only defines its elements once.
   <product-info>: thumbnails swap the main image; the variant picker updates ?variant=, the hidden id, price,
   availability, SKU, add-to-cart state, image and the WhatsApp link (all pre-rendered per variant in Liquid);
   add to cart posts to /cart/add.js and falls back to a normal form submit without JS.
   <product-recommendations>: fetches the filled section when it comes near the viewport. */
(function () {
  "use strict";

  if (!("customElements" in window) || customElements.get("product-info")) return;

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function updateCartCount(count) {
    document.querySelectorAll("#CartCount, [data-cart-count]").forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.hidden = false;
    });
  }

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var data = this.querySelector("script[data-variants]");
      try {
        this.variants = JSON.parse(data ? data.textContent : "[]");
      } catch (e) {
        this.variants = [];
      }
      var currentId = Number(this.dataset.currentVariant);
      this.variant = this.variants.find(function (v) { return v.id === currentId; }) || null;
      this.noMatch = false;

      this.form = this.querySelector("form[data-product-form]");
      this.idInput = this.form ? this.form.querySelector("[data-variant-id]") : null;
      this.picker = this.querySelector("[data-variant-picker]");

      this.addEventListener("click", this.onClick.bind(this));
      if (this.picker) {
        this.picker.addEventListener("change", this.onOptionChange.bind(this));
        this.markOptions(this.selectedOptions());
      }
      if (this.form) this.form.addEventListener("submit", this.onSubmit.bind(this));
    }

    onClick(event) {
      var thumb = event.target.closest("[data-thumb]");
      if (thumb && this.contains(thumb)) {
        this.showMedia(thumb.dataset.mediaId);
        return;
      }
      var copy = event.target.closest("[data-copy-link]");
      if (copy && this.contains(copy)) this.copyLink(copy);
    }

    /* ---------- gallery ---------- */
    showMedia(id) {
      if (id === null || id === undefined) return;
      id = String(id);
      var target = this.querySelector('[data-media-item][data-media-id="' + id + '"]');
      if (!target) return;
      this.querySelectorAll("[data-media-item]").forEach(function (item) {
        item.hidden = item !== target;
      });
      this.querySelectorAll("[data-thumb]").forEach(function (button) {
        if (button.dataset.mediaId === id) button.setAttribute("aria-current", "true");
        else button.removeAttribute("aria-current");
      });
    }

    /* ---------- variant picker ---------- */
    selectedOptions() {
      return Array.prototype.map.call(this.picker.querySelectorAll("[data-option]"), function (fieldset) {
        var checked = fieldset.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }

    onOptionChange(event) {
      var fieldset = event.target.closest("[data-option]");
      var current = fieldset ? fieldset.querySelector("[data-selected-value]") : null;
      if (current) current.textContent = event.target.value;

      var selected = this.selectedOptions();
      var variant = this.variants.find(function (v) { return sameOptions(v.options, selected); }) || null;
      this.markOptions(selected);
      this.applyVariant(variant);
    }

    /* Strike through values that would lead to a sold-out or missing combination (they stay selectable). */
    markOptions(selected) {
      var variants = this.variants;
      var soldOut = this.picker.dataset.labelSoldOut || "";
      var unavailable = this.picker.dataset.labelUnavailable || soldOut;
      this.picker.querySelectorAll("[data-option]").forEach(function (fieldset, index) {
        fieldset.querySelectorAll("input[type=radio]").forEach(function (input) {
          var options = selected.slice();
          options[index] = input.value;
          var match = variants.find(function (v) { return sameOptions(v.options, options); });
          var ok = Boolean(match && match.available);
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          label.classList.toggle("is-unavailable", !ok);
          var note = label.querySelector("[data-unavailable-note]");
          if (note) note.textContent = ok ? "" : " (" + (match ? soldOut : unavailable) + ")";
        });
      });
    }

    applyVariant(variant) {
      var add = this.querySelector("[data-add-button]");
      var addLabel = add ? add.querySelector("[data-add-label]") : null;
      var dynamic = this.querySelector("[data-dynamic-checkout]");
      var skuWrap = this.querySelector("[data-sku-wrap]");

      this.variant = variant;
      this.noMatch = !variant;

      if (!variant) {
        if (add) {
          add.hidden = false;
          add.disabled = true;
          if (addLabel) addLabel.textContent = add.dataset.labelUnavailable;
        }
        if (dynamic) dynamic.hidden = true;
        if (skuWrap) skuWrap.hidden = true;
        this.setStock("unavailable");
        this.setWhatsApp(this.dataset.waProduct);
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      this.dataset.currentVariant = variant.id;

      var priceWrap = this.querySelector("[data-price-wrap]");
      if (priceWrap && variant.priceHtml) priceWrap.innerHTML = variant.priceHtml;

      if (add) {
        add.hidden = Boolean(variant.onRequest);
        add.disabled = !variant.available || Boolean(variant.onRequest);
        if (addLabel) addLabel.textContent = variant.available ? add.dataset.labelAdd : add.dataset.labelSoldOut;
      }
      if (dynamic) dynamic.hidden = !variant.available || Boolean(variant.onRequest);
      this.setStock(variant.available ? "in" : "out");

      if (skuWrap) {
        var sku = skuWrap.querySelector("[data-sku]");
        if (sku) sku.textContent = variant.sku || "";
        skuWrap.hidden = !variant.sku;
      }

      if (variant.media) this.showMedia(variant.media);

      this.setWhatsApp(variant.wa || this.dataset.waProduct);

      if (this.dataset.updateUrl === "true" && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState(history.state, "", url.toString());
      }

      this.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: variant } }));
    }

    setWhatsApp(href) {
      if (!href) return;
      this.querySelectorAll("[data-whatsapp]").forEach(function (link) {
        link.href = href;
      });
    }

    setStock(state) {
      var el = this.querySelector("[data-availability]");
      if (!el) return;
      el.classList.toggle("is-in", state === "in");
      el.classList.toggle("is-out", state !== "in");
      el.textContent =
        state === "in" ? el.dataset.labelIn : state === "out" ? el.dataset.labelOut : el.dataset.labelUnavailable;
    }

    /* ---------- add to cart ---------- */
    onSubmit(event) {
      if (!window.fetch || !window.FormData) return; // normal form submit
      event.preventDefault();

      var self = this;
      var add = this.form.querySelector("[data-add-button]");
      if (add && add.getAttribute("aria-busy") === "true") return;
      if (add) {
        add.setAttribute("aria-busy", "true");
        add.disabled = true;
      }
      this.setMessage(null);

      var cartUrl = this.dataset.cartUrl || "/cart";
      var addUrl = (this.dataset.cartAddUrl || "/cart/add") + ".js";

      fetch(addUrl, {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(this.form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw data;
            return data;
          });
        })
        .then(
          function (item) {
            self.setMessage("success");
            document.dispatchEvent(new CustomEvent("cart:added", { detail: { item: item } }));
            return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
              .then(function (response) { return response.json(); })
              .then(function (cart) {
                updateCartCount(cart.item_count);
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart, item_count: cart.item_count } }));
              })
              .catch(function () {});
          },
          function (error) {
            var text = null;
            if (error && !(error instanceof Error)) {
              text = typeof error.description === "string" && error.description ? error.description : error.message;
            }
            self.setMessage("error", text);
          }
        )
        .finally(function () {
          if (!add) return;
          add.removeAttribute("aria-busy");
          add.disabled = self.noMatch || (self.variant ? !self.variant.available || Boolean(self.variant.onRequest) : false);
        });
    }

    setMessage(type, text) {
      var box = this.querySelector("[data-cart-message]");
      if (!box) return;
      box.textContent = "";
      if (!type) return;
      var message = document.createElement("div");
      message.className = "form-message form-message--" + type;
      if (type === "success") {
        message.appendChild(document.createTextNode(box.dataset.added + " · "));
        var link = document.createElement("a");
        link.href = box.dataset.cartUrl || "/cart";
        link.textContent = box.dataset.viewCart;
        message.appendChild(link);
      } else {
        message.textContent = text || box.dataset.error;
      }
      box.appendChild(message);
    }

    /* ---------- share ---------- */
    copyLink(button) {
      var url = button.dataset.copyLink;
      var label = button.querySelector("[data-copy-label]");
      var status = this.querySelector("[data-copy-status]");
      var copied = button.dataset.copiedLabel;

      function done() {
        if (label) {
          if (!label.dataset.original) label.dataset.original = label.textContent;
          label.textContent = copied;
          clearTimeout(button._copyTimer);
          button._copyTimer = setTimeout(function () {
            label.textContent = label.dataset.original;
          }, 2500);
        }
        if (status) status.textContent = copied;
      }

      function fallback() {
        var area = document.createElement("textarea");
        area.value = url;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        try {
          if (document.execCommand("copy")) done();
        } catch (e) {
          /* nothing else to try */
        }
        area.remove();
        button.focus();
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(done, fallback);
      } else {
        fallback();
      }
    }
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._observed || !this.dataset.url || this.children.length) return;
      this._observed = true;
      var self = this;

      function load() {
        fetch(self.dataset.url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, "text/html");
            var filled = doc.querySelector("product-recommendations");
            if (filled && filled.innerHTML.trim().length) self.innerHTML = filled.innerHTML;
          })
          .catch(function () {});
      }

      if (!("IntersectionObserver" in window)) {
        load();
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      observer.observe(this);
    }
  }

  customElements.define("product-info", ProductInfo);
  if (!customElements.get("product-recommendations")) {
    customElements.define("product-recommendations", ProductRecommendations);
  }
})();
